import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { HttpTestService } from './services/http.service';
import { loginmodel } from './models/login/login.model';
import { PlatformLocation } from '@angular/common';
import { sessionServices } from './services/session.services';
import { Idle } from 'idlejs/dist';
import $ from 'jquery';
import { EventListener } from '@angular/core/src/debug/debug_node';
import { SecurityService } from './services/security/security.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

	public sessionData: any;
	public errorMsg: string = "";
	public successMsg: string = "";
	public allUserData: any = [];
	public loggedInUserData: any = [];
	public passNotChanged: boolean = false;
	public loginmodel: loginmodel = new loginmodel
	public registeredUserData: any = "";
	public CreateUserResponseData: any = "";
	public sessionPOP: boolean = false;
	public sessionTimeout: number = 30;
	public serviceOn: boolean = false;
	public otpSend: boolean = false;
	public adData: any = [];
	public adClickResponseData: any = "";
	public generalBroadCast: any = [];
	public regeonalBroadCast: any = [];
	public zonalBroadCast: any = [];
	public today: any = new Date().getTime();
	public generalData: any;
	public viewChatpopupopen: boolean = false;
	public openChatCircle: boolean = true;
	public showChatBox: boolean = false;

	public innerWidth: any;

	public idle = new Idle().whenNotInteractive().within(this.sessionTimeout).do(() => {
		if (window.sessionStorage.getItem('sessionKey') != '' && window.sessionStorage.getItem('sessionKey') != undefined) {
			this.sessionPOP = true;
			window.sessionStorage.setItem('sessionKey', "");
		}
	}).start();

	// public idle = new Idle().whenNotInteractive().within(this.sessionTimeout).do(() => {
	// 	if (this.session.isLoggedIn()) {
	// 		this.sessionTimeoutPopup = true; 
	// 		window.sessionStorage.clear();
	// 	}
	// }).start();

	constructor(
		public session: sessionServices,
		public http: HttpTestService,
		public securityService: SecurityService,
		public router: Router, 
		public location: PlatformLocation) {

			// // Production code to restrict access to developer tools
			this.securityService.restrictDeveloperTools();

			// Productio code to detect if dev tools are open
			// setInterval(() => {
			// 	this.detectDevTools()
			// }, 10000);

		}

	// 	ngOnInit() {
	// 		this.getSession();
	// 		this.getAdData();
	// 		this.getBroadcastData();
	//     history.pushState(null, null, location.href);
	//     window.onpopstate = function () {
	//         history.go(1);
	// 		};

	// 		if(this.sessionData.credChange != "" && this.sessionData.credChange == this.sessionData.consumerId){
	// 			this.passNotChanged = true;
	// 		}

	// 		this.router.events.subscribe((evt) => {
	//             if (!(evt instanceof NavigationEnd)) {
	//                 return;
	//             }
	//             $('html, body').animate({ scrollTop: $(".icon-nav").offset().top }, 500);
	//         });
	// }

	ngOnInit() {
		this.innerWidth = window.innerWidth;
		// console.log("screen size: ", this.innerWidth)

		this.getSession();
		this.getAdData();
		this.getBroadcastData();
		if (this.sessionData.credChange != "" && this.sessionData.credChange == this.sessionData.consumerId) {
			this.passNotChanged = true;
		}

		this.router.events.subscribe((evt) => {
			if (!(evt instanceof NavigationEnd)) {
				return;
			}
			// $('html, body').animate({ scrollTop: $(".icon-nav").offset().top }, 500);
		});
	}

	

	// Production code to detect if dev tools are open
	detectDevTools() {
		let threshold = 100;
		const start = performance.now();
		debugger; // Execution pauses here when dev tools are open
		const end = performance.now();
		if (end - start > threshold) {
		  alert('Developer tools are open!');
		  // Optionally, redirect the user or log out
		  this.goToLogin();
		//   window.location.href = 'about:blank';
		}
	  }

	getSession = function () {
		var self = this;
		self.sessionData = self.session.getSessionDetails();
	}

	getConsumerDetails = function (e) {
		var self = this;
		self.errorMsg = "";
		self.successMsg = "";
		var requestedConsumer = self.sessionData.consumerId;
		if (self.loginmodel.SignInPass == requestedConsumer) {
			self.errorMsg = "Password cannot be same as consumer id.";
		} else {
			self.http.getUserDetailsByConsNo(requestedConsumer).subscribe(
				(data) => {
					self.registeredUserData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.registeredUserData = "";
				},
				() => {
					self.updateUser()
				});
		}
	}

	updateUser = function () {
		var self = this;
		self.errorMsg = "";
		self.successMsg = "";
		self.registeredUserData.password = self.loginmodel.SignInPass;

		self.http.createUser(self.registeredUserData).subscribe(
			(data) => {
				self.CreateUserResponseData = data;
			},
			(error) => {
				self.errorMsg = error;
			},
			() => {
				self.passNotChanged = false;
				self.successMsg = "Password changed for Consumer Id " + self.CreateUserResponseData.consumerNo + " successfully.";
			});
	}

	getBroadcastData = function () {
		var self = this;
		var genData = [];
		self.http.getGeneralBroadCast().subscribe(
			(data) => {
				genData = data;
			},
			(error) => {
				self.errorMsg = error;
				self.generalBroadCast = [];
			},
			() => {
				for (var i = 0; i < genData.length; i++) {
					if ((!genData[i].endDate || genData[i].endDate >= self.today) && (!genData[i].startDate || genData[i].startDate <= self.today) && genData[i].status === 1) {
						self.generalBroadCast.push(genData[i].messageBody);

					}
				}
			}
		);
		//  self.http.getGeneralBroadCast()
		// 	  .subscribe(
		// 		(data) => {
		// 		  genData = data;
		// 		  },
		// 		(error) => {
		// 			self.errorMsg = error;
		// 			 self.generalBroadCast = [];
		// 		},
		// 		() => {
		// 			for(var i = 0; i<genData.length; i++){
		// 				if(!genData[i].expirationDate || genData[i].expirationDate >= self.today){
		// 					self.generalBroadCast.push(genData[i]);
		// 				}
		// 			}
		// 		}
		// );

		if (self.sessionData.sessionStarted && self.sessionData.sessionRegion != '') {
			//var region = ((self.sessionData.sessionRegion).startsWith("GAYA"))?"GAYA":"ASANSOL";
			var regionName = ((self.sessionData.sessionRegion));
			var regData = [];
			var zoneData = [];
			self.http.getBlroRegionNameWiseBroadcastData(regionName).subscribe(
				(data) => {
					regData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.regeonalBroadCast = [];
				},
				() => {
					for (var i = 0; i < regData.length; i++) {
						if ((!regData[i].endDate || regData[i].endDate >= self.today) && (!regData[i].startDate || regData[i].startDate <= self.today) && regData[i].status === 1) {
							self.regeonalBroadCast.push(regData[i].messageBody);
						}
					}
				}
			);

			self.http.getMouzaZoneWiseBroadcastData(self.sessionData.sessionRegion, self.sessionData.cosumerZone).subscribe(
				(data) => {
					zoneData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.zonalBroadCast = [];
				},
				() => {
					for (var i = 0; i < zoneData.length; i++) {
						if ((!zoneData[i].expirationDate || zoneData[i].expirationDate >= self.today) && (!zoneData[i].startDate || zoneData[i].startDate <= self.today) && zoneData[i].status === 1) {
							self.zonalBroadCast.push(zoneData[i].messageBody);
						}
					}
				});
		}

		// self.http.getZonalBroadCast("ZONE", self.sessionData.cosumerZone).subscribe(
		// 	(data) => {
		// 		zoneData = data;
		// 	},
		// 	(error) => {
		// 		self.errorMsg = error;
		// 	    self.zonalBroadCast = [];
		// 		},
		// 		() => {
		// 			for(var i = 0; i<zoneData.length; i++){
		// 				if(!zoneData[i].expirationDate || zoneData[i].expirationDate >= self.today){
		// 					self.zonalBroadCast.push(zoneData[i]);
		// 				}
		// 			}
		// 		}
		// );
		// }
	}

	getAdData = function () {
		var self = this;
		self.http.getAdDetails().subscribe(
			(data) => {
				self.adData = data;
			},
			(error) => {
				self.errorMsg = error;
				self.adData = [];
			},
			() => {
				var refinedAd = [];
				for (var i = 0; i < self.adData.length; i++) {
					if (self.adData[i].status == "active") {
						refinedAd.push(self.adData[i]);
					}
				}
				self.adData = refinedAd;
			});
	}

	goToLogin = function () {
		var self = this;
		self.sessionPOP = false;
		window.location.replace('/login');
	}

	executeAd = function (id, towards) {
		var self = this;

		var postData = {
			"adId": id,
			"userId": (self.sessionData.sessionId != '') ? self.sessionData.sessionId : "-1",
			"remoteIp": "NA",
			"createDate": new Date().getTime()
		};

		self.http.postAdDetails(postData).subscribe(
			(data) => {
				self.adClickResponseData = data;
			},
			(error) => {
				self.errorMsg = error;
			},
			() => {
				window.open(towards);
			});
	}

	getBroadCastForPaymentNSC(blroRegionId, mouzaZoneId) {
		var self = this;
		var regData = [];
		var zoneData = [];
		self.regeonalBroadCast = [];
		self.zonalBroadCast = [];
		if (blroRegionId != null || blroRegionId != undefined)
			self.http.getBlroRegionIdWiseBroadcastData(blroRegionId).subscribe(
				(data) => {
					regData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.regeonalBroadCast = [];
				},
				() => {
					for (var i = 0; i < regData.length; i++) {
						if ((!regData[i].endDate || regData[i].endDate >= self.today) && (!regData[i].startDate || regData[i].startDate <= self.today) && regData[i].status === 1) {
							self.regeonalBroadCast.push(regData[i].messageBody);
						}
					}
				}
			);

		if ((mouzaZoneId != null || mouzaZoneId != undefined) && (blroRegionId != null || blroRegionId != undefined))
			self.http.getMouzaZoneIDWiseBroadcastData(mouzaZoneId, blroRegionId).subscribe(
				(data) => {
					zoneData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.zonalBroadCast = [];
				},
				() => {
					for (var i = 0; i < zoneData.length; i++) {
						if ((!zoneData[i].expirationDate || zoneData[i].expirationDate >= self.today) && (!zoneData[i].startDate || zoneData[i].startDate <= self.today) && zoneData[i].status === 1) {
							self.zonalBroadCast.push(zoneData[i].messageBody);
						}
					}
				}
			);
	}

	getBroadCastForMyConsumption(blroRegionName, mouzaZoneName) {
		var self = this;
		var regData = [];
		var zoneData = [];
		self.regeonalBroadCast = [];
		self.zonalBroadCast = [];

		if (blroRegionName != null || blroRegionName != undefined)
			self.http.getBlroRegionNameWiseBroadcastData(blroRegionName).subscribe(
				(data) => {
					regData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.regeonalBroadCast = [];
				},
				() => {
					for (var i = 0; i < regData.length; i++) {
						if ((!regData[i].endDate || regData[i].endDate >= self.today) && (!regData[i].startDate || regData[i].startDate <= self.today) && regData[i].status === 1) {
							self.regeonalBroadCast.push(regData[i].messageBody);
						}
					}
				}
			);

		if ((mouzaZoneName != null || mouzaZoneName != undefined) && (blroRegionName != null || blroRegionName != undefined))
			self.http.getMouzaZoneWiseBroadcastData(blroRegionName, mouzaZoneName).subscribe(
				(data) => {
					zoneData = data;
				},
				(error) => {
					self.errorMsg = error;
					self.zonalBroadCast = [];
				},
				() => {
					for (var i = 0; i < zoneData.length; i++) {
						if ((!zoneData[i].expirationDate || zoneData[i].expirationDate >= self.today) && (!zoneData[i].startDate || zoneData[i].startDate <= self.today) && zoneData[i].status === 1) {
							self.zonalBroadCast.push(zoneData[i].messageBody);
						}
					}
				}
			);
	}
	checkLogout(event) {

		setInterval(() => {
			clearInterval(1000)
			var x = document.getElementById("minimizePopUp");
			// x.style.position = "-webkit-sticky";
			// x.style.marginTop = event.clientY;
			// x.style.left = event.clientX;
		}, 1000)
		this.viewChatpopupopen = true;
	}

	// checkLogout(event) {
	// 	console.log("Logout button clicked");
	// 	this.viewChatpopupopen = true;
	// 	console.log("Popup should be visible:", this.viewChatpopupopen);
	// }

	// minimize() {
	// 	console.log("minimize")
	// 	this.viewChatpopupopen = false; // Hide popup
	// 	this.openChatCircle = true; // Ensure chat circle is visible
	// 	this.showChatBox = false; // Hide chat box
	// }

	minimize() {
		console.log("Minimize button clicked");
		this.viewChatpopupopen = false;
		this.openChatCircle = true;
		this.showChatBox = false;
		console.log("Popup hidden:", this.viewChatpopupopen);
		console.log("Chat circle visible:", this.openChatCircle);
	}
	
	openChatBox() {
		console.log("openChatBox")
		this.openChatCircle = false;
		this.showChatBox = true;
		
	}
	//logout function
	logout() {
		window.sessionStorage.setItem('sessionKey', "");
		self.location.replace('');
	}

}



// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/app.component.ts